import React from 'react';
import {applyMiddleware, createStore} from "redux";
import reducers from "reducers";
import thunk from "redux-thunk";
import createHistory from "history/createHashHistory";
import {routerMiddleware} from "react-router-redux";

export const history = createHistory();

const middleware = routerMiddleware(history);

export const store = createStore(
    reducers,
    {},
    applyMiddleware(middleware, thunk)
);

export default store;


// WEBPACK FOOTER //
// ./store.js